<div class="ShareContainer Flexbox Flexbox--column Justify--center Gap--normal">
  <div class="Flexbox Justify--center Align--center TitleContainer">
    <button (click)="closeButtonClicked()" mat-icon-button class="CloseMenuButton"><mat-icon>close</mat-icon></button>
    <h3>Share Your Ring</h3>
  </div>
  <div class="Flexbox Flexbox--column DetailsContainer Gap--smallest">
    <span>{{ configuredItem().design?.displayName }}</span>
    <span>{{ configuredItem().form?.displayName }}</span>
    <span>
      @if(configuredItem().secondaryMaterial?.displayName !== configuredItem().primaryMaterial?.displayName) {
        {{ configuredItem().secondaryMaterial?.displayName }} /
      }
      {{ configuredItem().primaryMaterial?.displayName }}
    </span>
  </div>
    <div class="Flexbox Flexbox--column Gap--smaller">
      <div class="Flexbox Align--center Gap--smaller">
        <mat-form-field appearance="outline" class="ShareLinkTextArea">
          <mat-label>Share Ring Link</mat-label>
          <input #shareLinkTextArea matInput (keypress)="shareURLFieldKeyDown($event)" [value]="shareLink()">
        </mat-form-field>
        <button mat-icon-button class="NavButton ShareButton ThemeColorAccent" #ShareButton (click)="copyShareClicked()"><mat-icon>assignment</mat-icon></button>
      </div>
      @if (shouldShowCopyConfirmation()) {
        <span class="CopyConfirmation">Share url copied!</span>
      }
    </div>
</div>
